import React from 'react';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import LoginForm from '../auth/LoginForm';

// redirectTo intentionally omitted - LoginForm falls back to a role-based
// redirect (see defaultRedirectFor in LoginForm.js) since this is the
// unified entry point for admins, speakers, and attendees alike.
//
// eventId in the URL happens when this page is reached via the "you already
// have an account, log in" link in a signup-start email (see
// EmailService.sendSignupStartEmail) or the "already have an account" link
// on the /signup 'exists' step - both cases preserve eventId in the URL.
// Passed straight through as a prop rather than stashed anywhere: without an
// eventId (e.g. the navbar's plain "Sign in" link), this login has nothing
// to do with registering for an event, full stop - there's no separate
// "pending" state that could go stale and fire on some later, unrelated
// login.
const AttendeeLogin = () => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('eventId');

  return (
    <LoginForm
      title={intl.formatMessage({ id: 'header.login', defaultMessage: 'Sign in' })}
      subtitle={intl.formatMessage({ id: 'login.subtitle', defaultMessage: 'Access your HEARTS account' })}
      eventId={eventId}
      showSignupLink
    />
  );
};

export default AttendeeLogin;
